import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { industryCards } from '../data/content';

const { FiSearch, FiX, FiChevronRight } = FiIcons;

export default function IndustryNav() {
  const [query, setQuery] = useState('');
  const filtered = industryCards.filter(card => 
    card.label.toLowerCase().includes(query.toLowerCase())
  );

  const handleClick = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="bg-white/80 backdrop-blur-xl border-b border-gray-100 sticky top-0 z-50 shadow-apple-sm">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="relative flex-shrink-0 w-full sm:w-72">
            <SafeIcon icon={FiSearch} className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-mutedBlue" />
            <input 
              type="text" 
              placeholder="Search industries..." 
              value={query}
              onChange={e => setQuery(e.target.value)}
              className="w-full pl-11 pr-10 py-3 text-sm border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-sage focus:border-transparent bg-gray-50/50 text-deepNavy placeholder-gray-400 transition-all"
            />
            {query && (
              <button 
                onClick={() => setQuery('')}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center rounded-full bg-gray-200 text-gray-500 hover:bg-gray-300 transition-colors"
              >
                <SafeIcon icon={FiX} className="w-3 h-3" />
              </button>
            )}
          </div>
          <div className="flex flex-wrap gap-2 flex-1 min-w-0">
            {filtered.map(card => {
              const IconComp = FiIcons[card.icon];
              return (
                <button 
                  key={card.id}
                  onClick={() => handleClick(card.id)}
                  className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-deepNavy bg-sage-lightest hover:bg-sage hover:text-white rounded-2xl transition-all duration-300 whitespace-nowrap group"
                >
                  {IconComp && <SafeIcon icon={IconComp} className="w-4 h-4 text-mutedBlue group-hover:text-white transition-colors" />}
                  {card.label}
                  <SafeIcon icon={FiChevronRight} className="w-3 h-3 opacity-0 group-hover:opacity-100 -ml-1 transition-all duration-300" />
                </button>
              );
            })}
            {filtered.length === 0 && (
              <span className="text-sm text-deepNavy-lighter italic py-2">No industries match your search.</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}